import { Chip, ChipProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StatusFilterChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<ChipProps & { selected?: boolean }>(({ theme, selected }) => ({
  height: '2rem',
  padding: '1rem 0.5rem',
  borderRadius: '1.125rem',
  fontSize: '0.875rem',
  fontWeight: 400,
  cursor: 'pointer',
  backgroundColor: selected ? theme.palette.colors.turquoise : theme.palette.background.default,
  color: selected ? '#fff' : theme.palette.monochrome.monoChrome6,
  border: selected ? 'none' : `1px solid ${theme.palette.monochrome.monoChrome3}`,
  '&:hover': {
    backgroundColor: selected ? theme.palette.colors.turquoise : theme.palette.monochrome.monoChrome2,
  },
}));

export default StatusFilterChip;
